import { getSamedayArea } from "./dateUtils";
import { useMongoUpdate } from "./useMongoQuery";


export const useUpdateBooking = (isMany?:boolean, completed?: () => void) => {
    const [updateDataMutation, { error }] = useMongoUpdate("bookings", isMany, {}, completed);
    /**
     * Function to update data
     * @param queryValue _id or query(if isMany is true) of document to update
     * @param set New data to set
     * @returns Mutation variables {updateData, error}
     */
    const updateData = async (queryValue: string | number | KV, set: { [key: string]: any }): Promise<{ updatedData: { [key: string]: any }, error: Error | undefined }> => {
        const { data } = await updateDataMutation(isMany ? queryValue as KV : { _id: queryValue }, set);
        const updatedData: { [key: string]: any } = data || {}
        return { updatedData, error };
    };
    return updateData;
}

export const useUpdateRelatedBooking = (completed?: () => void) => {
  const [updateDataMutation, { error }] = useMongoUpdate("bookings", true, {}, completed);
    /**
     * Function to update same day same patient data
     * @param date Updating Date 
     * @param patientID Updating patientID
     * @param set Updating field and value
     * @returns Mutation variables {updateData, error}
     */
    const updateData = async (date: Date, patientID: string, set: { [key: string]: any }): Promise<{ updatedData: { [key: string]: any }, error: Error | undefined }> => {
      const [start, end] = getSamedayArea(date)
      const { data } = await updateDataMutation({ start: { $gte: start, $lt: end }, patientID }, set);
      const updatedData: { [key: string]: any } = data || {}
      return { updatedData, error };
  };
  return updateData;
}

export const useUpdateVisit = (completed?: () => void) => {
  const [updateDataMutation, { error }] = useMongoUpdate("bookings", false, {}, completed);
  /**
   * Function to update data
   * @param queryValue _id or query(if isMany is true) of document to update
   * @param set New data to set
   * @returns Mutation variables {updateData, error}
   */
  const updateData = async (queryValue: string, set: { [key: string]: any }): Promise<{ updatedData: { [key: string]: any }, error: Error | undefined }> => {
      const { data } = await updateDataMutation({ _id: queryValue}, set);
      const updatedData: { [key: string]: any } = data || {}
      return { updatedData, error };
  };
  return updateData;
}
